module.exports = __webpack_public_path__ + "img/3-1-3.03837839.png";